
<div>
    <ng-container *ngIf="!formGroup.get(controlName).disabled || !detailMode">
        <mat-label class="font-weight-400">{{label}}</mat-label>
        <mat-form-field appearance="outline" floatLabel="always" color="accent" style="width: 100%;">
            <input #inputField matInput type="text" 
                [formControl]="autoCompleteControl" [matAutocomplete]="auto"
                [placeholder]="placeholder">
            <mat-autocomplete autoActiveFirstOption [displayWith]="displayItem" #auto="matAutocomplete">
                <mat-option *ngFor="let item of searchedItems$ | async"                 
                    [value]="item"
                    (onSelectionChange)="selectedOptionChanged(item)">
                    {{ item[descriptionPropertyName] }}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
        <!-- errors -->
        <ng-container *ngIf="autoCompleteControl.touched && !formGroup.get(controlName).value"> 
            <mat-error *ngIf="formGroup.get(controlName).hasError('required')">{{'INPUT.REQUIRED' | translate}}</mat-error> 
        </ng-container> 
        <ng-container *ngIf="autoCompleteControl.touched && autoCompleteControl.dirty && !!autoCompleteControl.value"> 
            <mat-error *ngIf="!(searchedItems$ | async)?.length && formGroup.get(controlName).invalid">{{'INPUT.SUGGEST_NO_MATCH' | translate}}</mat-error> 
        </ng-container> 
    </ng-container>

    <ng-container *ngIf="formGroup.get(controlName).disabled && detailMode">
        <mat-label class="font-weight-400">{{label}}</mat-label>
        <p style="font-weight: bold;">{{(_initialValue$ | async)[descriptionPropertyName]}}</p>
    </ng-container>      
</div>